"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _tinycolor = require("@ctrl/tinycolor");

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("./redux/selectors"));

var _LoginPage = _interopRequireDefault(require("./pages/auth/LoginPage"));

var _Router = _interopRequireDefault(require("./router/Router"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class App extends _react.default.Component {
  render() {
    // Need this due to some weird parcel problem that results in TinyColor not being
    // compiled in. This is a dependency of antd and we think its being pruned during "tree shaking"
    const tc = _tinycolor.TinyColor;
    const {
      isAuthenticated,
      isAuthenticating
    } = this.props;

    if (!isAuthenticated && !isAuthenticating) {
      return /*#__PURE__*/_react.default.createElement(_LoginPage.default, null);
    }

    if (isAuthenticating) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Authenticating...");
    }

    if (!isAuthenticated) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error...");
    }

    return /*#__PURE__*/_react.default.createElement("div", null, process.env.ENV !== 'production' && /*#__PURE__*/_react.default.createElement("div", {
      id: "test-env-banner"
    }, ' ', _lodash._.toUpper(process.env.ENV), ' ', "ENVIRONMENT", ' '), /*#__PURE__*/_react.default.createElement(_Router.default, null));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  authenticatedUserId: selectors.getAuthenticatedUserId,
  isAuthenticated: selectors.isAuthenticated,
  isAuthenticating: selectors.isAuthenticating
});

var _default = (0, _reactRedux.connect)(mapStateToProps)(App);

exports.default = _default;